import React from 'react';
import PropTypes from 'prop-types';
import { BaasicButton, BaasicFormControls} from "core/components";
import { defaultTemplate } from 'core/hoc';
import { FacilityOrderTemplateNewFlowCreate } from "application/facility-order-new-flow/components";

function CreateFacilityOrderTemplateUSIntakeNewFlowModalTemplate({ createFacilityOrderTemplateUSIntakeNewFlowModalStore, t }) {
    const {
        form,
        modalParams,
        patient,
        facilityOrderTemplateNewFlowCreateViewStore,
        disabled
    } = createFacilityOrderTemplateUSIntakeNewFlowModalStore;

    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Create a new order</h3>
            </div>

            <div className="modal__body">
                <h3 className='type--sml u-mar--bottom--med'>
                    {patient && patient.lastName && ` ${patient.lastName}`}
                    {patient && patient.lastName && patient.firstName && ', '}
                    {patient && patient.firstName && `${patient.firstName}`}
                </h3>

                <FacilityOrderTemplateNewFlowCreate
                    facilityOrderTemplateNewFlowCreateViewStore={facilityOrderTemplateNewFlowCreateViewStore}
                    disabled={disabled}
                />
            </div>
            <div className='modal__footer is-right'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={t('EDIT_FORM_LAYOUT.CANCEL')}
                    onClick={() => modalParams.close()}
                    disabled={form.submitting || form.validating}
                />
                <BaasicFormControls
                    form={form}
                    onSubmit={form.onSubmit}
                    disabled={form.submitting || form.validating}
                    label="Create"
                    className='btn btn--med btn--primary'
                />
            </div>
        </section >
    )
}

CreateFacilityOrderTemplateUSIntakeNewFlowModalTemplate.propTypes = {
    createFacilityOrderTemplateUSIntakeNewFlowModalStore: PropTypes.object,
    t: PropTypes.func
};

export default defaultTemplate(CreateFacilityOrderTemplateUSIntakeNewFlowModalTemplate);
